import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { PrimaryButton } from "components/designV2/buttons/primaryButton";
import { SecondaryButton } from "components/designV2/buttons/secondaryButton";
import { Modal } from "components/designV2/modal/modal";
import { Text } from "components/designV2/text/text";
import { useSignOut } from "components/nav/hooks/useSignOut";
import { useAuthStore } from "stores/authStore/authStore";

export const ClockStampAccessPromptModal = (): JSX.Element => {
  const { t } = useTranslation();
  const [authState] = useAuthStore();
  const history = useHistory();
  const signOut = useSignOut();

  const close = (): void => history.replace("/company/schedule");

  return (
    <Modal
      isOpen
      label={t("StampClock.AccessPromptTitle")}
      size="compact"
      showCloseButton={false}
      onClose={close}
      footer={
        <>
          <SecondaryButton label={t("General.Cancel")} onClick={close} />
          <PrimaryButton
            label={t("General.SignOut")}
            isLoading={authState.isLoading}
            disabled={authState.isLoading}
            onClick={() => void signOut()}
          />
        </>
      }
    >
      <Text as="div" typography="b2">
        {t("StampClock.AccessPromptDescription")}
      </Text>
      <Text as="div" typography="b2">
        <Text as="strong" typography="b1">
          {t("StampClock.AccessPromptDeviceQuestion")}
        </Text>
        <br />
        {t("StampClock.AccessPromptInstructions")}
      </Text>
    </Modal>
  );
};
